import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// This controller handles the hiring manager profile comparison visualization
export default class extends Controller {
  static targets = ["comparisonChart", "diffList", "field", "oldValue", "newValue", "significanceIndicator"]
  
  connect() {
    if (this.hasComparisonChartTarget) {
      this.initializeChart()
    }
    
    // Show the first field comparison by default
    if (this.hasFieldTarget && this.fieldTargets.length > 0) {
      this.showField(this.fieldTargets[0].dataset.field)
    }
  }
  
  initializeChart() {
    // Get the data from the data attribute
    const profileData = JSON.parse(this.comparisonChartTarget.dataset.profiles)
    
    // Create datasets for the radar chart
    const datasets = []
    
    // Add current profile data
    if (profileData.current) {
      datasets.push({
        label: 'Current Profile',
        data: [
          profileData.current.dominance * 100 || 0,
          profileData.current.influence * 100 || 0,
          profileData.current.steadiness * 100 || 0,
          profileData.current.conscientiousness * 100 || 0
        ],
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgb(54, 162, 235)',
        pointBackgroundColor: 'rgb(54, 162, 235)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(54, 162, 235)'
      })
    }
    
    // Add previous profile data if available
    if (profileData.previous) {
      datasets.push({
        label: 'Previous Profile',
        data: [
          profileData.previous.dominance * 100 || 0,
          profileData.previous.influence * 100 || 0,
          profileData.previous.steadiness * 100 || 0,
          profileData.previous.conscientiousness * 100 || 0
        ],
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgb(255, 99, 132)',
        pointBackgroundColor: 'rgb(255, 99, 132)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(255, 99, 132)'
      })
    }
    
    // Create the chart
    this.chart = new Chart(this.comparisonChartTarget, {
      type: 'radar',
      data: {
        labels: ['Dominance', 'Influence', 'Steadiness', 'Conscientiousness'],
        datasets: datasets
      },
      options: {
        elements: {
          line: {
            borderWidth: 3
          }
        },
        scales: {
          r: {
            angleLines: {
              display: true
            },
            suggestedMin: 0,
            suggestedMax: 100
          }
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return `${context.dataset.label}: ${context.raw.toFixed(1)}%`
              }
            }
          }
        }
      }
    })
  }
  
  // Show details for a specific field
  showField(field) {
    // Hide all fields first
    this.fieldTargets.forEach(fieldElement => {
      fieldElement.classList.add('hidden')
    })
    
    // Show the selected field
    const selectedField = this.fieldTargets.find(f => f.dataset.field === field)
    if (selectedField) {
      selectedField.classList.remove('hidden')
      
      // Update active state in the field list
      this.diffListTarget.querySelectorAll('button').forEach(button => {
        if (button.dataset.field === field) {
          button.classList.add('bg-blue-100', 'text-blue-800')
          button.classList.remove('bg-gray-100', 'text-gray-800')
        } else {
          button.classList.remove('bg-blue-100', 'text-blue-800')
          button.classList.add('bg-gray-100', 'text-gray-800')
        }
      })
    }
  }
  
  // Visualize a field when clicked
  visualizeField(event) {
    const field = event.currentTarget.dataset.field
    this.showField(field)
  }
}